module.exports = __webpack_public_path__ + "static/media/noise.a8957aea.png";